import React from 'react';
import { Card, CardContent, Typography, Box, Button, SvgIcon } from '@mui/material';

interface SummaryCardProps {
    title: string;
    value: string | number;
    icon: React.ReactNode;
    lastModified?: string;
    onOpen?: () => void;
    sx?: any;
    accentColor?: string;
}

const cardSx = {
    width: 360,
    height: 240,
};

const SummaryCard: React.FC<SummaryCardProps> = ({
    title,
    value,
    icon,
    lastModified = '12.08.2025',
    onOpen,
    accentColor = '#1f8f1f'
}) => {
    return (
        <Card sx={cardSx}>
            <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">{title}</Typography>
                    {onOpen && (
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={onOpen}
                            style={{ borderRadius: 20 }}
                        >
                            Open
                        </Button>
                    )}
                </Box>
            </CardContent>

            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                px={3}
                py={2}
                sx={{
                    mx: '30px',
                    bgcolor: accentColor,
                }}
            >
                <SvgIcon
                    viewBox="0 0 67 67"
                    style={{ width: '50.545px', height: '42.358px' }}
                >
                    {icon}
                </SvgIcon>

                <Typography variant="h3" style={{ color: '#fff', fontWeight: 600 }}>
                    {value}
                </Typography>
            </Box>

            <CardContent>
                <Typography
                    variant="body2"
                    color="textSecondary"
                    align="center"
                >
                    Last modified {lastModified}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default SummaryCard;
